import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";


const DataViewPermesisonList = (props) => {
    const { addForm, update } = props;
    const [data, setData] = useState([]);
    const [itemsPerPage] = useState(100);

    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  
    const paginate = (pageNumber) => {
      setCurrentPage(pageNumber);
    };

  const { sendRequest: getRolePer } = useHttp();

  useEffect(() => {
   
    getRolePer(
      {
        url: `/api/dataview/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          setData(res);
        }
      }
    );
  }, [getRolePer]);


  return (
    <>
    <div className="content-wrapper">
      <div className="row mx-2">
        <div className="col-6">
          <label className="card-title mx-3 my-3">
            Data View Permesison
          </label>
        </div>

        <div className="col-6 text-right">
          <button
            type="button"
            className="btn  btn-primary mx-3 my-3"
            onClick={() => {
              addForm(true);
              props.update(false);
            }}
          >
            Add Data View Permissions
          </button>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body" style={{ padding: "0.4rem" }}>
                <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Employee Name</th>
                          <th>Employee Code</th>
                          <th>Work Emailid</th>
                          <th>Warehouse Name</th>
                          <th>Designation Name</th>
                          <th>Department Name</th>
                          {/* <th>Edit</th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.employeeName}</td>
                                <td>{itm.employeeCode}</td>
                                <td>{itm.workEmailId}</td>
                                <td>{itm.warehouseName}</td>
                                <td>{itm.designationName}</td>
                                <td>{itm.departmentName}</td>

                                {/* <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i> 
                                  </button>
                                </td> */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                </div>
                {/* /.card-body */}
                <div className="card-footer clearfix">
                  <Pagination
                    totalItems={data.length}
                    itemsPerPage={itemsPerPage}
                    onPageChange={paginate}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </>
  )
}

export default DataViewPermesisonList